var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M15.4141 0.833313C15.1582 0.833313 14.902 0.922659 14.707 1.10187L13 2.66665L17 6.33331L18.707 4.76853C19.098 4.41012 19.098 3.82981 18.707 3.47231L16.1211 1.10187C15.9256 0.922659 15.6699 0.833313 15.4141 0.833313ZM11.5 4.04165L0 14.5833V18.25H4L15.5 7.70831L11.5 4.04165Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }